import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_AssociatesTable = _resolveComponent("AssociatesTable")!
  const _component_BuildingsTable = _resolveComponent("BuildingsTable")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_selectUser = _resolveComponent("selectUser")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.step,
    "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.step) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, {
        class: "pb-5",
        value: 0
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            modelValue: _ctx.allConditionsCompleted,
            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.allConditionsCompleted) = $event)),
            ref: "form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[69] || (_cache[69] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("La société"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event)),
                        label: "Nom du dossier",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact",
                        "data-cy": "bundle-company-name"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companySiret,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companySiret) = $event)),
                        label: "Siret",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companySiren,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companySiren) = $event)),
                        label: "Siren",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.apeCode,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.apeCode) = $event)),
                        label: "Code APE",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyStreetNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyStreetNumber) = $event)),
                        label: "Numéro de l'adresse",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyStreetName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyStreetName) = $event)),
                        label: "Nom de voie",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyPostalCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyPostalCode) = $event)),
                        label: "Code Postal",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyCity,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyCity) = $event)),
                        label: "Ville",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.socialReason,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.socialReason) = $event)),
                        label: "Raison sociale",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.legalForm,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.legalForm) = $event)),
                        label: _ctx.$t('settings.legalForm'),
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "label", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      (_ctx.companyIncomeCategory === 'RF')
                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 0,
                            disabled: _ctx.isSent,
                            outlined: "",
                            modelValue: _ctx.bundleFixedVariables.C5,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bundleFixedVariables.C5) = $event)),
                              _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitManualChange()))
                            ],
                            items: _ctx.earningTypes,
                            "item-title": "text",
                            "item-value": "value",
                            "hide-details": "auto",
                            label: "Type de revenus",
                            density: "compact",
                            class: "pl-2"
                          }, null, 8, ["disabled", "modelValue", "items"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      (_ctx.companyIncomeCategory === 'BNC')
                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                            key: 0,
                            disabled: "",
                            modelValue: _ctx.companyActivity,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyActivity) = $event)),
                            label: "Nature de l'activité",
                            rules: [_ctx.rules.hasValueInMyFile],
                            required: "",
                            outlined: "",
                            "hide-details": "auto",
                            class: "pl-2",
                            density: "compact"
                          }, null, 8, ["modelValue", "rules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Détails de la société"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        disabled: "",
                        outlined: "",
                        modelValue: _ctx.companyIncomeCategory,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyIncomeCategory) = $event)),
                        items: _ctx.incomeCategories,
                        "item-title": "name",
                        "item-value": "id",
                        "hide-details": "auto",
                        label: "Catégorie de revenu",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        disabled: "",
                        outlined: "",
                        class: "pl-2",
                        modelValue: _ctx.companyTaxRegime,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.companyTaxRegime) = $event)),
                        items: _ctx.taxRegimes,
                        "item-title": "name",
                        "item-value": "id",
                        "hide-details": "auto",
                        label: "Régime fiscal",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        disabled: "",
                        outlined: "",
                        class: "pl-2",
                        modelValue: _ctx.companyVatSystem,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.companyVatSystem) = $event)),
                        items: _ctx.vatSystems,
                        "item-title": "name",
                        "item-value": "id",
                        "hide-details": "auto",
                        label: "Régime TVA",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        outlined: "",
                        disabled: "",
                        class: "pl-2",
                        modelValue: _ctx.companyTaxSystemType,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.companyTaxSystemType) = $event)),
                        items: _ctx.taxSystemTypes,
                        "item-title": "name",
                        "item-value": "id",
                        "hide-details": "auto",
                        label: "Imposition",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companyStartBusinessDate,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyStartBusinessDate) = $event)),
                        label: "Date de début d'activité",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.companySalaryCount,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.companySalaryCount) = $event)),
                        label: "Nombre de salarié(s)",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Responsable légal"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      (!_ctx.legalRepresentativeUsers.length)
                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                            key: 0,
                            disabled: _ctx.isSent,
                            modelValue: _ctx.bundleFixedVariables.legalRepresentative,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bundleFixedVariables.legalRepresentative) = $event)),
                            label: "Nom du représentant légal",
                            required: "",
                            outlined: "",
                            "hide-details": "auto",
                            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.emitManualChange())),
                            density: "compact"
                          }, null, 8, ["disabled", "modelValue"]))
                        : (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 1,
                            outlined: "",
                            modelValue: _ctx.bundleFixedVariables.legalRepresentative,
                            "onUpdate:modelValue": [
                              _cache[21] || (_cache[21] = ($event: any) => ((_ctx.bundleFixedVariables.legalRepresentative) = $event)),
                              _cache[22] || (_cache[22] = ($event: any) => (
                                (_ctx.emitManualChange(), _ctx.onLegalRepresentativeChange())
                            ))
                            ],
                            items: _ctx.legalRepresentativeUsers,
                            "item-title": "text",
                            "item-value": "value",
                            "hide-details": "auto",
                            label: "Nom du représentant légal",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        disabled: _ctx.isSent,
                        outlined: "",
                        class: "pl-2",
                        modelValue: _ctx.bundleFixedVariables.legalRepresentativeType,
                        "onUpdate:modelValue": [
                          _cache[23] || (_cache[23] = ($event: any) => ((_ctx.bundleFixedVariables.legalRepresentativeType) = $event)),
                          _cache[24] || (_cache[24] = ($event: any) => (_ctx.emitManualChange()))
                        ],
                        items: _ctx.legalRepresentativeTypes,
                        "item-title": "text",
                        "item-value": "value",
                        "hide-details": "auto",
                        label: "Qualité du responsable légal",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("La période"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingPeriodStart,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.accountingPeriodStart) = $event)),
                        label: "Date de début",
                        rules: [_ctx.rules.hasValueInMyExercices],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact",
                        "data-cy": "bundle-accounting-period-start"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingPeriodEnd,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.accountingPeriodEnd) = $event)),
                        label: "Date de fin",
                        rules: [_ctx.rules.hasValueInMyExercices],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact",
                        "data-cy": "bundle-accounting-period-end"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingPeriodLength,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.accountingPeriodLength) = $event)),
                        label: "Durée (en mois)",
                        rules: [_ctx.rules.hasValueInMyExercices],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      (!_ctx.isStartBusinessDate)
                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                            key: 0,
                            disabled: !!_ctx.previousAccountingPeriod,
                            modelValue: _ctx.variables.previousAccPeriod.start,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.variables.previousAccPeriod.start) = $event)),
                            label: "Date de début de la période précédente",
                            onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.emitManualChange())),
                            outlined: "",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["disabled", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: !!_ctx.previousAccountingPeriod,
                        modelValue: _ctx.variables.previousAccPeriod.end,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.variables.previousAccPeriod.end) = $event)),
                        label: "Date de fin de la période précédente",
                        onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.emitManualChange())),
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: !!_ctx.previousAccountingPeriod,
                        modelValue: _ctx.variables.previousAccPeriod.duration,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.variables.previousAccPeriod.duration) = $event)),
                        label: "Durée (en mois) de la période précédente",
                        onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.emitManualChange())),
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[73] || (_cache[73] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Codes ROF"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.rofIScode,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.rofIScode) = $event)),
                        label: "Impôts sur les sociétés",
                        outlined: "",
                        prefix: _ctx.rofISprefix,
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue", "prefix"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.rofCVAEcode,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.rofCVAEcode) = $event)),
                        label: "CVAE",
                        outlined: "",
                        prefix: _ctx.rofCVAEprefix,
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "prefix"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.rofBundleCode,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.rofBundleCode) = $event)),
                        label: "Liasse fiscale",
                        outlined: "",
                        prefix: _ctx.rofBundlePrefix,
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "prefix"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[74] || (_cache[74] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("OGA"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "d-flex justify-center align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: _ctx.ogaEnrolment,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.ogaEnrolment) = $event)),
                        "hide-details": "",
                        disabled: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentNumberId,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.ogaEnrolmentNumberId) = $event)),
                        label: "Numéro d'identification",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact",
                        class: "pl-2"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentYear,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.ogaEnrolmentYear) = $event)),
                        label: "Année",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentSiret,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.ogaEnrolmentSiret) = $event)),
                        label: "SIRET",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentDesignation,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.ogaEnrolmentDesignation) = $event)),
                        label: "Désignation",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentAddress,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.ogaEnrolmentAddress) = $event)),
                        label: "Adresse",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentPostalCode,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.ogaEnrolmentPostalCode) = $event)),
                        label: "Code postal",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.ogaEnrolmentCity,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.ogaEnrolmentCity) = $event)),
                        label: "Ville",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Informations complémentaires"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: _ctx.isSent,
                        modelValue: _ctx.bundleFixedVariables.V2,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.bundleFixedVariables.V2) = $event)),
                        label: "Date de cessation",
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: _ctx.isSent,
                        modelValue: _ctx.bundleFixedVariables.Y6,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.bundleFixedVariables.Y6) = $event)),
                        label: "Date de dépôt provisoire",
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        disabled: "",
                        modelValue: _ctx.bundleFixedVariables.C1,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.bundleFixedVariables.C1) = $event)),
                        "true-value": "Oui",
                        "false-value": "Non",
                        label: "Comptabilité informatisée"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        disabled: "",
                        modelValue: _ctx.companySubjectToVAT,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.companySubjectToVAT) = $event)),
                        label: "Soumis à TVA"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      (_ctx.variables.isComputerizedAccounting)
                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                            key: 0,
                            disabled: "",
                            modelValue: _ctx.bundleFixedVariables.C2,
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.bundleFixedVariables.C2) = $event)),
                            label: "Nom du logiciel utilisé",
                            rules: [_ctx.rules.hasValue],
                            required: "",
                            outlined: "",
                            "hide-details": "auto",
                            class: "pl-2",
                            density: "compact"
                          }, null, 8, ["modelValue", "rules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[76] || (_cache[76] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Le cabinet"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmName,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.accountingFirmName) = $event)),
                        label: "Nom du cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmSiret,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.accountingFirmSiret) = $event)),
                        label: "Siret cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmSiren,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.accountingFirmSiren) = $event)),
                        label: "Siren cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmApeCode,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.accountingFirmApeCode) = $event)),
                        label: "Code APE cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmSocialReason,
                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.accountingFirmSocialReason) = $event)),
                        label: "Raison sociale cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmAddress,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.accountingFirmAddress) = $event)),
                        label: "Adresse cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmPostalCode,
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.accountingFirmPostalCode) = $event)),
                        label: "Code Postal cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: "",
                        modelValue: _ctx.accountingFirmCity,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.accountingFirmCity) = $event)),
                        label: "Ville cabinet",
                        rules: [_ctx.rules.hasValueInMyFile],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[77] || (_cache[77] = [
                      _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Le signataire"), -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center px-2 py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.bundleFixedVariables.Y1,
                        "onUpdate:modelValue": [
                          _cache[58] || (_cache[58] = ($event: any) => ((_ctx.bundleFixedVariables.Y1) = $event)),
                          _cache[59] || (_cache[59] = ($event: any) => (_ctx.emitManualChange()))
                        ],
                        items: _ctx.accountingSignatories,
                        "item-title": "text",
                        "item-value": "value",
                        rules: [_ctx.rules.hasValue],
                        required: "",
                        disabled: _ctx.isSent,
                        outlined: "",
                        "hide-details": "auto",
                        label: "Nom complet du signataire",
                        density: "compact",
                        clearable: !_ctx.isSent,
                        "onClick:clear": _cache[60] || (_cache[60] = ($event: any) => (_ctx.bundleFixedVariables.Y1 = null))
                      }, null, 8, ["modelValue", "items", "rules", "disabled", "clearable"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: _ctx.isSent,
                        modelValue: _ctx.bundleFixedVariables.Y2,
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.bundleFixedVariables.Y2) = $event)),
                        label: "Qualité du signataire",
                        rules: [_ctx.rules.hasValue],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        onChange: _cache[62] || (_cache[62] = ($event: any) => (_ctx.emitManualChange())),
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        disabled: _ctx.isSent,
                        modelValue: _ctx.bundleFixedVariables.signatureCity,
                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.bundleFixedVariables.signatureCity) = $event)),
                        label: "Lieu de la signature",
                        rules: [_ctx.rules.hasValue],
                        required: "",
                        outlined: "",
                        "hide-details": "auto",
                        onChange: _cache[64] || (_cache[64] = ($event: any) => (_ctx.emitManualChange())),
                        class: "pl-2",
                        density: "compact"
                      }, null, 8, ["disabled", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" })
                ]),
                _: 1
              }),
              (
                        _ctx.companyDetails && _ctx.companyDetails.shareCapital && _ctx.companyDetails.shareTotal
                    )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[78] || (_cache[78] = [
                            _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Juridique"), -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center align-center px-2 py-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AssociatesTable, {
                              company: _ctx.companyDetails,
                              onShareQuantityDifferenceIsOverZero: _cache[65] || (_cache[65] = ($event: any) => (
                                    _ctx.$emit('shareQuantityDifferenceIsOverZero')
                                ))
                            }, null, 8, ["company"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isSCI)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                            _createElementVNode("h4", { class: "ml-5" }, _toDisplayString("Immeubles"), -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center align-center px-2 py-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BuildingsTable, { company: _ctx.companyDetails }, null, 8, ["company"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        class: "pb-5",
        value: "selectUser"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_selectUser, {
                    class: "px-1",
                    modelValue: _ctx.signerUser,
                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.signerUser) = $event)),
                    companyId: _ctx.companyId,
                    type: 'NATURAL_PERSON',
                    withEmail: true
                  }, null, 8, ["modelValue", "companyId"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}